'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var Promise = require('es6-promise').Promise;
// 服务器地址
var SERVERURL = {
    development: 'http://fmcweb.sqaproxy.dasouche-inc.net/',
    prepub: 'http://fmc.prepub.souche-inc.com/',
    production: 'https://fmc.souche-inc.com/'
}[process.env.NODE_ENV] || 'https://fmc.souche-inc.com/';

exports.default = {
    SERVERURL: SERVERURL,
    loadJs: function loadJs(url) {
        return new Promise(function (resolve) {
            var sc = document.createElement('script');
            sc.src = url;
            sc.onload = function () {
                return resolve();
            };
            var s = document.getElementsByTagName('script')[0];
            s.parentNode.insertBefore(sc, s);
        });
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@souche-f2e/statistics/dist/helper.js
// module id = si0I
// module chunks = 11